module.exports = __webpack_public_path__ + "img/dep_partysupply.f28ac1eb.png";